import React, { useEffect, useState, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useResourceContext, ReferenceField, TextField, RecordContextProvider } from 'react-admin';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField as MuiTextField, IconButton, Button, Paper, Typography, Box
} from '@mui/material';

// Mapping functions for workflow fields
const getWorkflowCategoryLabel = (id) => {
  const categories = [
    { id: 1, name: "استبعاد وأنذار السائقين" },
    { id: 2, name: "استبعاد وأنذار المرافقين" }
  ];
  const category = categories.find(cat => cat.id === parseInt(id));
  return category ? category.name : id;
};

const getWorkflowSubcategoryLabel = (id) => {
  const subcategories = [
    { id: 1, name: "مسودة طلب استبعاد أو إنذار" },
    { id: 2, name: "اعتماد مشرف المنطقة لطلب الاستبعاد أو الإنذار" },
    { id: 3, name: "اعتماد اخصائي الامن والسلامة لطلب الاستبعاد أو الإنذار" },
    { id: 4, name: "اعتماد مدير المنطقة لطلب الاستبعاد أو الإنذار" },
    { id: 5, name: "طلب الاستبعاد أو الإنذار مقفل" },
    { id: 6, name: "طلب الاستبعاد أو الإنذار ملغى" }
  ];
  const subcategory = subcategories.find(sub => sub.id === parseInt(id));
  return subcategory ? subcategory.name : id;
};

const BlacklistedDriverInput = () => {
  const { control, setValue, getValues } = useFormContext();
  const operationPlans = useWatch({ control, name: 'operation_plan', defaultValue: [] });
  const isSearchDone = useWatch({ control, name: 'is_search_done', defaultValue: false });
  const resource = useResourceContext();

  const [plans, setPlans] = useState(operationPlans);
  const { reset } = useFormContext();


  const columnConfig = [

    { field: 'id', label: 'رقم التذكرة', ttype: 'readonly' },
    { field: 'workflow_category', label: 'نموذج الطلب', ttype: 'readonly' },
    { field: 'workflow_subcategory', label: 'الاجراء المطلوب', ttype: 'readonly' },
    { field: 'driver_nid', label: 'رقم هوية السائق/المرافق', ttype: 'readonly' },
    { field: 'education_area_id', label: 'المنطقة', ttype: 'reference', resource: 'domain_sectors', source: 'name' },
    { field: 'education_zone_id', label: 'إدارة التعليم', ttype: 'reference', resource: 'domain_administrations', source: 'name' },
    { field: 'academic_year', label: 'العام الدراسي بالهجري', ttype: 'readonly' },
    { field: 'period_id', label: 'الفترة', ttype: 'reference', resource: 'ods_operational_periods', source: 'period_id' },
    { field: 'vendor_id', label: 'المتعهد', ttype: 'reference', resource: 'vendors', source: 'vendor_name' },
    { field: 'accident_type', label: 'الإجراء المتخذ', ttype: 'readonly' },
    { field: 'incident_cause', label: 'نوع المخالفة', ttype: 'readonly' },
    { field: 'previous_warning_count', label: 'عدد الانذارات', ttype: 'readonly' },
    { field: 'previous_warning_text', label: 'نوع الانذار', ttype: 'readonly' },
  ];



  useEffect(() => {

    setPlans(operationPlans); // Sync with form state whenever operation_plan changes
  }, [operationPlans]);

  return (
    <>
      {/* Only show if search is done and plans exist */}
      {isSearchDone && plans && plans.length > 0 ? (

        <Box sx={{ width: '95vw', maxWidth: '95vw', overflow: 'auto', maxHeight: '400px' }}>

          <TableContainer
            component={Paper}
            sx={{
              width: 'max-content', // Forces table to expand horizontally within the scrollable container
              minWidth: 1500,
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {columnConfig.map((col) => (
                    <TableCell
                      key={col.field}
                      sx={{
                        maxHeight: '50px',
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        width: 'auto', // Allows stretching
                        minWidth: '100px', // Ensures it doesn't collapse
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}

                </TableRow>
              </TableHead>
              <TableBody>
                {plans.map((plan) => (
                  <TableRow key={plan.id}>


                    {columnConfig.map((col) => {
                      let displayValue = plan[col.field] ? plan[col.field] : "--";
                      
                      // Apply label mapping for specific fields
                      if (col.field === 'workflow_category' && plan[col.field]) {
                        displayValue = getWorkflowCategoryLabel(plan[col.field]);
                      } else if (col.field === 'workflow_subcategory' && plan[col.field]) {
                        displayValue = getWorkflowSubcategoryLabel(plan[col.field]);
                      }
                      
                      return (
                        <TableCell key={col.field} sx={{
                          maxHeight: '50px',
                          height: '50px',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                          width: 'auto',
                          minWidth: '100px',
                        }}>
                          {col.ttype === 'reference' && plan[col.field] ? (
                            <RecordContextProvider value={plan}>
                              <ReferenceField 
                                source={col.field}
                                reference={col.resource}
                                link={false}
                              >
                                <TextField source={col.source} />
                              </ReferenceField>
                            </RecordContextProvider>
                          ) : (
                            <span>{displayValue}</span>
                          )}
                        </TableCell>
                      );
                    })}



                    {/*   <TableCell>
        <IconButton onClick={() => handleDeletePlan(plan.id)}>
          <Delete />
        </IconButton>
      </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>

            </Table>
            {/*       <Button onClick={handleAddPlan} startIcon={<Add />} variant="contained" style={{ marginTop: '1em' }}>
        Add Plan
      </Button> */}
          </TableContainer>
        </Box>

      ) : isSearchDone && plans.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: 'gray' }}>
         لا يوجد طلب استبعاد محدد فى النظام بعد
        </div>
      ) : null}
    </>
  );
};

export default BlacklistedDriverInput;
